import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRoutes } from "react-router-dom";
import routes from "@/routes";
import "@/styles/reset.css";
import "@/styles/fonts.css";
import "@/styles/index.css";
import ScrollToTop from "@/utils/ScrollToTop";
import Footer from "@/components/Footer";
import SmoothScrollProvider from "@/components/SmoothScrollProvider";
import Header from "@/components/Header";
import { DrawerProvider } from "@/lib/context/DrawerManagerContext";
const App = () => {
    const routing = useRoutes(routes);
    return (_jsx(DrawerProvider, { children: _jsxs("div", { className: "relative flex flex-col min-h-screen font-inter bg-background text-neutral-900", children: [_jsx(ScrollToTop, {}), _jsx(Header, {}), _jsxs(SmoothScrollProvider, { children: [_jsx("main", { className: "flex-grow", children: routing }), _jsx(Footer, {})] })] }) }));
};
export default App;
